import { render } from "./Frame.vue?vue&type=template&id=20b0c392&scoped=true"
import script from "./Frame.vue?vue&type=script&lang=js"
export * from "./Frame.vue?vue&type=script&lang=js"

import "./Frame.vue?vue&type=style&index=0&id=20b0c392&scoped=true&lang=scss"

import exportComponent from "/var/www/frontend/mobileproject/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b0c392"]])

export default __exports__